import React from 'react';

function Blog() {
  return (
    <div className="blog">
      <div className="container">
        <h1>Blog</h1>
        <div className="blog-posts">
          <p>No blog posts available at the moment. Check back later!</p>
        </div>
      </div>
    </div>
  );
}

export default Blog; 